// extracted by css-extract-rspack-plugin
var _1 = "y1zzK";
var _2 = "tw_4j";
var _3 = "zRnKH";
export { _1 as "container", _2 as "content", _3 as "scrollableContent" }
